import { Link } from "react-router-dom";
import styled from "styled-components";

const Logo = require("../assets/FullLogo.png");
const bg404_1 = require("../assets/404bg_1.png");
const bg404_2 = require("../assets/404bg_2.png");

const NotFoundPage = () => {
  return (
    <Container>
      <Box>
        <Left>
          <div>
            <Link to="/">
              <LogoIMG src={Logo} alt="Logo" />
            </Link>
          </div>
          <div>
            <h1>Страница не найдена</h1>
            <p>
              Вы попали на страницу, которая не существует, <br /> или вы
              перешли по неправильному адресу.
            </p>
          </div>
          <LinkButton>
            <Link to="/">Главная страница</Link>
          </LinkButton>
        </Left>
        <Right>
          <FirstBG>
            <img src={bg404_1} alt="backlogo" />
          </FirstBG>
          <SecondBG>
            <img src={bg404_2} alt="upsidelogo" />
          </SecondBG>
        </Right>
      </Box>
    </Container>
  );
};

export default NotFoundPage;

const Container = styled.div`
  min-height: 710px;
  height: 100vh;
  background-image: linear-gradient(
    0deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(223, 246, 255, 1) 100%
  );
`;

const Box = styled.div`
  max-width: 1200px;
  justify-content: space-between;
  display: flex;
  padding: 100px 0;
  margin: 0 auto;

  @media screen and (max-width: 992px) {
    flex-direction: column;
    justify-content: center;
    gap: 50px;
    align-items: center;
    padding: 50px 0;
  }

  @media screen and (max-width: 768px) {
    padding: 25px 0;
  }
`;

const Left = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;

  @media screen and (max-width: 992px) {
    justify-content: center;
    align-items: center;
    gap: 20px;
  }

  color: #000000;

  h1 {
    font-size: 60px;
    font-weight: 700;
    margin-bottom: 20px;

    @media screen and (max-width: 992px) {
      font-size: 36px;
      text-align: center;
      margin-bottom: 10px;
    }

    @media screen and (max-width: 768px) {
      font-size: 30px;
    }
  }

  p {
    font-size: 20px;
    font-weight: 400;

    @media screen and (max-width: 992px) {
      text-align: center;
      font-size: 18px;
    }

    @media screen and (max-width: 768px) {
      font-size: 16px;
    }
  }
`;

const Right = styled.div`
  position: relative;

  @media screen and (max-width: 992px) {
    padding-top: 20px;
  }
`;

const LogoIMG = styled.img`
  height: 50px;
`;

const LinkButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  border: none;
  cursor: pointer;

  width: 200px;
  height: 55px;

  padding: 10px;

  color: #ffffff;
  font-size: 16px;
  line-height: 1.55;
  font-weight: 500;
  border-radius: 10px;
  background-color: #559ed6;
  background-position: center center;
  border-color: transparent;
  border-style: solid;
  transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out,
    border-color 0.3s ease-in-out;

  &:hover {
    background-color: #2476b5;
  }

  @media screen and (max-width: 992px) {
    margin-top: 20px;
  }

  a {
    text-align: center;
  }
`;

const FirstBG = styled.div`
  position: absolute;
  right: 100px;

  @media screen and (max-width: 992px) {
    right: -100px;
  }

  img {
    width: 400px;

    @media screen and (max-width: 992px) {
      width: 210px;
    }
  }
`;

const SecondBG = styled.div`
  position: absolute;
  right: 40px;
  top: -70px;

  @media screen and (max-width: 992px) {
    right: -120px;
    top: 2px;
  }

  img {
    width: 527px;

    @media screen and (max-width: 992px) {
      width: 245px;
    }
  }
`;
